import * as React from "react";
const SvgCloud4 = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 511.31", ...props }, /* @__PURE__ */ React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" }, /* @__PURE__ */ React.createElement("g", { id: "frame" }, /* @__PURE__ */ React.createElement("rect", { width: 512, height: 511.31, style: {
  fill: "none"
} })), /* @__PURE__ */ React.createElement("g", { id: "dark" }, /* @__PURE__ */ React.createElement("circle", { cx: 170.33, cy: 245.01, r: 67.89, style: {
  fill: "#2680c0",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 5
} }), /* @__PURE__ */ React.createElement("circle", { cx: 310.64, cy: 214.99, r: 110.98, style: {
  fill: "#1870af",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 5
} }), /* @__PURE__ */ React.createElement("circle", { cx: 96.55, cy: 315.27, r: 60.72, style: {
  fill: "#1870af",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 5
} }), /* @__PURE__ */ React.createElement("circle", { cx: 403.82, cy: 299.63, r: 76.18, style: {
  fill: "#2680c0",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 6
} }), /* @__PURE__ */ React.createElement("path", { d: "M403.82,315.58a83.46,83.46,0,0,1-83.58,83.58H153.08a38,38,0,1,1,8.29-75.07,53.18,53.18,0,0,1,86.14-49.7,83.58,83.58,0,0,1,156.31,41.19Z", style: {
  fill: "#64b1e8",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 5
} }), /* @__PURE__ */ React.createElement("path", { d: "M320.24,399.16A84.08,84.08,0,0,0,343,396", style: {
  fill: "#64b1e8",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 5
} }))));
export default SvgCloud4;
